module.exports = __webpack_public_path__ + "media/stylesheets/opensans400-7dafb1a4bab4938a38b2d68d9c4575a9.woff";